import React, {useContext} from 'react';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import RenderComponents from "./RenderByType/RenderComponents";

const Header = (props) => {
    const {component: {children = [], styles: sourceStyles}, path, index: parentIndex} = props;
    const {onDropComponent, onDropMultipleComponents, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const hasChildren = children && children.length;
    const styles = sourceStyles ? sourceStyles[0] : {};

    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.componentTarget,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });

    return (
        <AppBar position="static" style={{...styles, color: 'black'}} ref={drop}>
            <Toolbar variant="dense" style={{...styles, color: 'black'}}>
                {hasChildren ? (
                    children.map((item, index) => {
                        return (
                            <RenderComponents
                                key={index}
                                type={item.type}
                                item={item}
                                index={index}
                                path={`${path}.children.${index}`}
                                parentPath={path}
                            />
                        )
                    })
                ) : (
                    isOverCurrent && (
                        <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                        </div>
                    )
                )}
            </Toolbar>
        </AppBar>
    )
}

export default Header;